export const rootLinks = {
  root: () => '/',
  inner: () => '/portal',
};
